<template>
    <div class="EntityDetailsStats">
        <OverviewMetricCard
            title="Umsatz diesen Monat"
            :value="displayRevenue"
            icon="ri-money-euro-circle-line"
            theme="green"
            size="small"
            :loading="isLoading"
        />

        <OverviewMetricCard
            title="Tage gearbeitet"
            :value="displayDaysWorked"
            icon="ri-calendar-check-line"
            theme="blue"
            size="small"
            :loading="isLoading"
        />

        <OverviewMetricCard
            title="€/km"
            :value="displayEuroPerKm"
            icon="ri-road-map-line"
            theme="orange"
            size="small"
            :loading="isLoading"
        />

        <OverviewMetricCard
            title="Schichtzeit"
            :value="displayShiftTime"
            icon="ri-timer-line"
            theme="cyan"
            size="small"
            :loading="isLoading"
        />

        <OverviewMetricCard
            title="Arbeitszeit"
            :value="displayWorkTime"
            icon="ri-briefcase-line"
            theme="indigo"
            size="small"
            :loading="isLoading"
        />

        <OverviewMetricCard
            title="Pausenzeit"
            :value="displayPauseTime"
            icon="ri-pause-circle-line"
            theme="orange"
            size="small"
            :loading="isLoading"
        />
    </div>
</template>

<script>
import OverviewMetricCard from '@/components/OverviewMetricCard.vue';
import { distanceToString, timeToString } from '@/lib/helper';

const formatCurrency = (value) => {
    if (value === 0) return '€0,00';
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    }).format(value);
};

const formatEuroPerKm = (value) => {
    if (value === 0) return '€0,00';
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};

export default {
    name: 'EntityDetailsStats',
    components: {
        OverviewMetricCard,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        stats: {
            type: Object,
            required: true,
        },
    },
    computed: {
        displayRevenue() {
            return formatCurrency(this.stats.revenue || 0);
        },
        displayDaysWorked() {
            return this.stats.daysWorked || 0;
        },
        displayEuroPerKm() {
            return formatEuroPerKm(this.stats.euroPerKm || 0);
        },
        displayShiftTime() {
            return timeToString(this.stats.shiftTime || 0, { withLabel: true });
        },
        displayWorkTime() {
            return timeToString(this.stats.workTime || 0, { withLabel: true });
        },
        displayPauseTime() {
            return timeToString(this.stats.pauseTime || 0, { withLabel: true });
        },
    },
};
</script>

<style lang="scss" scoped>
.EntityDetailsStats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

@media (max-width: 768px) {
    .EntityDetailsStats {
        grid-template-columns: 1fr;
        gap: 10px;
        margin-bottom: 20px;
    }
}
</style>
